import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
export const getSatisfactionSurveyStatsDataEndpoint = {
    [surveyEndpointIds.GET_SATISFACTION_SURVEY_STATS_DATA]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
    },
};
